import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const ToggleProfilePhotoFlaggedApi = {
  togglePhotoFlagged: async (user_id) => {
    try {
      const response = await axiosInstance.post(
        Configs.toggleProfilePhotoFlaggedEp,
        {
          user_id: user_id,
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Failed to toggle photo flag");
      }
    } catch (error) {
      console.error("Error toggling photo flag:", error);
      return null;
    }
  },
};

export default ToggleProfilePhotoFlaggedApi;
